import React, { useState, useEffect } from "react";
import "./teams.scss";
import { IonButton } from "@ionic/react";
import _ from "lodash";
import HomeGroupSms from "../../components/Shared/HomeGroupSms/HomeGroupSms";
import { teamsListService } from "./teams.service";
import { CONSTANTS } from "../../constants";
import { rolePermissionsService } from "../../services/rolePermissions.service";
import { utilService } from "../../services";
import AccordionComponent from "../Home/components/AccordionComponent/AccordionComponent";
import TeamCreation from "../../components/Shared/TeamsCreationModal/TeamCreationModal";
import Loader from "../../components/Shared/Loader/Loader";
import {useHistory, useLocation} from "react-router"
import { useNetwork } from "../../helpers/NetworkContext";
import { useTranslation } from "react-i18next";

interface teammatesProps {
  isFromUserCard?: boolean;
  selectedDoctorData?: any;
  isFromCaseHistoryDetails?: any;
  updateTeamList?: any;
  fromSelectDropdown?: boolean;
  searchInput?: any;
}

const TeamsPage: React.FC<teammatesProps> = (props) => {

  const location:any = useLocation();
  const { t } = useTranslation("teams");
  const history = useHistory();
  const {selectedNetwork} =  useNetwork()

  const [showGroupSmsModal, setShowGroupSmsModal]: any = useState(false);
  const [showCreateTeamModal, setShowCreateTeamModal]: any = useState(false);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [otherUserList, setOtherUserList]: any = useState({});
  const [addedUsersList, setAddedUsersList]: any = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [fullTeamList,setFullTeamList] = useState<any[]>([])
  const [showTeamEditModal, setShowTeamEditModal] = useState(false);
  const [selectedTeam,setSelectedTeam] = useState<any>()


  useEffect(() => {
    getTeammatesList();
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    setPageNo(1);
  }, []);

  useEffect(()=>{
    if(fullTeamList.length>0&&location?.state?.teamID){
      const selected = fullTeamList?.find((team:any)=>team?.scheduleId===location?.state?.teamID)
      setSelectedTeam(selected)
      setShowTeamEditModal(true)
    }
  },[fullTeamList])

  let doctorListMessage = {
    componentName: CONSTANTS.COMPONENTS.FILE_SHARE,
    isMultiSelectEnabled: true,
    isShowColorBadge: false,
  };

  const getTeammatesList = async () => {
    let params: any = {
      user_guid: props.selectedDoctorData
        ? props.selectedDoctorData.guid
        : utilService.getLoggedUserGuid(),
    };

    setShowLoader(true);
    const respTeammatesList = await teamsListService.getTeammatesListData(
      params,selectedNetwork?.value??''
    );
    if (respTeammatesList.isSuccess && respTeammatesList.result) {
      setOtherUserList(respTeammatesList!.result!.otherUserList);
      setAddedUsersList(respTeammatesList!.result!.otherUserList.added);
    }
    setShowLoader(false);
  };

  const userUnLinked = (unLikedUser: any) => {
    if (unLikedUser) {
      getTeammatesList();
    }
  };

  const checkIfTeammatesListIsEmpty = () => {
    return addedUsersList && !_.isEmpty(addedUsersList) ? false : true;
  };

  const editTeam = (teamData: any) => {};



  useEffect(()=>{
    if(otherUserList?.added){
      const scheduleResponse = otherUserList?.added
      let ScheduleResponseArray = Object.keys(scheduleResponse)?.map(
        (key: any) => {
          return {
            scheduleName: key,
            scheduleDoctorList: scheduleResponse[key].data,
            scheduleBadgeCount: scheduleResponse[key].data.length,
            scheduleId: scheduleResponse[key].scheduleId,
            id: key,
            ownTeam: scheduleResponse[key].ownTeam,
            teamAdmin: scheduleResponse[key].teamAdmin,
            teamSiteId: scheduleResponse[key].teamSiteId,
            teamStartDate: scheduleResponse[key].teamStartDate,
            teamStartTime: scheduleResponse[key].teamStartTime,
            teamExpiryDate: scheduleResponse[key].teamExpiryDate,
            teamExpiryTime: scheduleResponse[key].teamExpiryTime,
            teamName: scheduleResponse[key].teamName,
          };
        }
      );
      setFullTeamList(ScheduleResponseArray)
    }
  },[otherUserList])

  useEffect(()=>{
    window.addEventListener('beforeunload', ()=>{history.replace({ ...location, state: null });});

    return () => {
      window.removeEventListener('beforeunload', ()=>{history.replace({ ...location, state: null });});
    };
  },[])

  const updatedTeamList = (isSuccess: any) => {
    if (isSuccess) {
      const updateLinked = userUnLinked(isSuccess)
    }
  };


  return (
    <div className={`teams-container ${!props.isFromUserCard ? "teams-standalone-page" : ""}`}>
      <div className="teams-page-container">
        <div className="teams-header d-flex">
          <div className="d-flex align-items-center">
           <span className="title-name">{t("teammates")}</span>
          </div>
        </div>
        <div className="button-container" hidden={props.isFromUserCard}>
          <div className="btn-wrapper">
            <IonButton
              className="button secondary-transparent-btn button-xsm btn-curved"
              onClick={() => setShowGroupSmsModal(true)}
              disabled={checkIfTeammatesListIsEmpty()}
            >
          {t("groupSms")}
            </IonButton>
            <HomeGroupSms
              showModal={showGroupSmsModal}
              doctorListDataFromParent={"doctorData"}
              onOk={() => {
                setShowGroupSmsModal(false);
              }}
              onCancel={() => {
                setShowGroupSmsModal(false);
              }}
              accordionList={otherUserList}
            ></HomeGroupSms>
          </div>
          <div className="btn-wrapper">
            <IonButton
              className="button secondary-transparent-btn button-xsm btn-curved"
              onClick={() => setShowCreateTeamModal(true)}
            >
              {t("createTeam")}
            </IonButton>
            <TeamCreation
              showModal={showCreateTeamModal}
              createTeam={true}
              onOk={() => {
                setShowCreateTeamModal(false);
              }}
              onCancel={() => {
                setShowCreateTeamModal(false);
              }}
              fullTeamList={fullTeamList}
            ></TeamCreation>
          </div>
        </div>
      </div>
      <div className="teammates-container">
        {showLoader ? (
          <div className="loader-container">
            <Loader></Loader>
          </div>
        ) : (
          <div>
            {addedUsersList && !_.isEmpty(addedUsersList) ? (
              <div
                className={`accordion-container ${
                  utilService.getScreenSize() !== "small"
                    ? "col-lg-12 home-accordian-section"
                    : ""
                }
                    ${props.isFromUserCard ? "teammates-list-height" : ""}
                  `}
              >
                <AccordionComponent
                  accordionList={otherUserList}
                  isFromTeams={true}
                  isFromUserCard={props.isFromUserCard}
                  userUnLinked={userUnLinked}
                  editTeam={editTeam}
                  isFromCaseHistoryDetails={props.isFromCaseHistoryDetails}
                />
              </div>
            ) : (
              <div className="p-3 text-center" id="no-teammate">
        {t("noTeammates")}
              </div>
            )}
          </div>
        )}
      </div>
      <TeamCreation
        showModal={showTeamEditModal}
        teamId={location?.state?.teamID}
        teamDetails={selectedTeam}
        teamEdit={true}
        fromAccordionUserCard={false}
        updateTeamList={updatedTeamList}
        onOk={() => {
          setShowTeamEditModal(false);
          history.replace({ ...location, state: null });
        }}
        onCancel={() => {
          setShowTeamEditModal(false);
          history.replace({ ...location, state: null });
        }}
        fullTeamList={fullTeamList}
      ></TeamCreation>
    </div>
  );
};

export default TeamsPage;
